import {ContextMessage as Message} from '@epic-core/localization';
import PropTypes from 'prop-types';
import React from 'react';

import {mapPlaylist} from '../../utils/StatUtils';

const statMatcher = /^br_([a-zA-Z0-9]+)_([a-zA-Z0-9]+)_([a-zA-Z0-9]+)_([a-zA-Z0-9]+)$/;
const placeTop = /^placetop([0-9]+)$/;

export default function PlayerStat({stat, platform, playlist}) {
  if (!stat) {
    return <div className="player-stat empty" />;
  }
  const {name, value} = stat;
  const statType = statMatcher.exec(name);
  if (
    !statType ||
    !statType[1] ||
    statType[2] !== platform ||
    statType[4] !== mapPlaylist(playlist)
  ) {
    return <div className="player-stat empty" />;
  }
  const placement = placeTop.exec(statType[1]);
  let placementPosition = 0;
  if (placement && placement[1]) {
    placementPosition = placement[1];
  }
  return (
    <div className="player-stat">
      <div className="stat-title">
        <Message
          code={
            placementPosition
              ? 'epic.fortnite.leaderboard.placement'
              : `epic.fortnite.stat.${statType[1]}`
          }
          args={[placementPosition]}
        />
      </div>
      <div className="stat-value">{value}</div>
    </div>
  );
}

PlayerStat.propTypes = {
  stat: PropTypes.object,
  platform: PropTypes.string,
  playlist: PropTypes.string,
};
